(function(){
  'use strict';
  function normalise(q){
    return String(q||'')
      .replace(/\bsur[\s-]?ron\b/gi,'Sur-Ron')
      .replace(/\blight\s*bee\b/gi,'Light Bee')
      .replace(/\bultra\s*bee\b/gi,'Ultra Bee')
      .replace(/\bstorm\s*bee\b/gi,'Storm Bee')
      .replace(/\btl[\s-]?3000\b/gi,'TL-3000')
      .replace(/\btl[\s-]?4000\b/gi,'TL-4000')
      .replace(/\btl[\s-]?5500\b/gi,'TL-5500')
      .trim();
  }
  function enhancePredictive(){
    var Klass=customElements.get('predictive-search');if(!Klass||Klass.prototype.emxEnhanced)return;
    Klass.prototype.emxEnhanced=true;
    var originalGet=Klass.prototype.getQuery;
    Klass.prototype.getQuery=function(){return normalise(originalGet.call(this));};
    var originalRender=Klass.prototype.renderSearchResults;
    if(originalRender){
      Klass.prototype.renderSearchResults=function(markup){
        originalRender.call(this,markup);
        var root=this;
        requestAnimationFrame(function(){
          var products=root.querySelectorAll('[data-predictive-search] li, #predictive-search-results-products-list li');
          var visible=Array.prototype.filter.call(products,function(li){return !!li.querySelector('a[href*="/products/"]');}).length;
          if(visible===0&&root.getQuery()){window.emxTrack&&window.emxTrack('emx_search_no_results',{query:root.getQuery()});}
        });
      };
    }
  }
  if(window.customElements){customElements.whenDefined('predictive-search').then(enhancePredictive).catch(function(){});}
  document.addEventListener('submit',function(e){
    var form=e.target;if(!form||!form.matches('form[action*="/search"]'))return;
    var input=form.querySelector('input[name="q"]');if(!input)return;
    var before=input.value,after=normalise(before);
    if(after!==before){input.value=after;window.emxTrack&&window.emxTrack('emx_search_alias_normalized',{from:before,to:after});}
  },true);
})();
